export function heroShapedImagesAdaptiveBg() {
    let $parent = $(".hero-section.has-shaped-images");
    let bg = $parent.find(".hero-bg");
    let infoBlock = $parent.find(".shaped-images .image");
    let infoBlockHeight = 0;
    let $win = $(window);

    let setBgHeight = function () {
        if (infoBlock.length) {
            infoBlockHeight = infoBlock.innerHeight() / 2

            let distance = infoBlockHeight;

            $(bg).css({
                "height": "calc(100% - " + Math.round(distance) + "px)"
            })
        }
    };

    setBgHeight();

    $win.on("resize", function () {
        setBgHeight();

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroShapedImagesAdaptiveBg.js